<template>
	<div class="Banner" ref="BannerWrap">
		<img src="../assets/img/knowledgeService.jpg" alt="banner" class="pc_banner" />
		<img src="../assets/img/banner_mobile.jpg" alt="banner" class="mobile_banner" />
	</div>
</template>

<script>
export default{
	data(){
		return{
			Hei:0
		}
	},
	mounted() {
		// this.GetBanner();
	},
	methods:{
		// 获取banner
		GetBanner(){
			this.$fetch('/api/adLinks')
			.then((res)=>{
				console.log(res);
			}).catch((err)=>{
				throw err;
			});
		}
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
	.pc_banner{
		display: none;
	}
	.Banner{
		padding: 0 .25rem;
		box-sizing: border-box;
	}
	.mobile_banner{
		margin: .3rem auto .4rem;
	}
}
@media screen and (min-width: 1029px) {
	.mobile_banner{
		display: none;
	}
	
}
.Banner{
	width: 100%;
	height: auto;
	overflow: hidden;
}
.Banner img{
	width: 100%;
	height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue